import React from 'react';
import { formatPeriodLabel } from './periodFormat';

const TYPE_LABELS = { kpi: 'KPI', performance: 'Performance Data', report: 'Report' };
const EMPTY = {
  submitted: 'No submissions awaiting your review.',
  approved: 'No approved submissions.',
  rejected: 'No rejected submissions.',
};

export function ReviewQueueTable({ rows, status, onReview }) {
  if (!rows || rows.length === 0) {
    return <p className="submissions-empty">{EMPTY[status] || 'Nothing here.'}</p>;
  }
  const dateLabel = status === 'submitted' ? 'Submitted' : 'Reviewed';
  return (
    <table className="submissions-table">
      <thead>
        <tr><th>Employee</th><th>Team Lead</th><th>Country</th><th>Type</th><th>Period</th><th>{dateLabel}</th><th></th></tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const when = status === 'submitted' ? r.submitted_at : r.reviewed_at;
          return (
            <tr key={r.id}>
              <td>{r.submitter?.name || '—'}</td>
              <td>{r.submitter?.team_lead?.name || '—'}</td>
              <td>{r.countries?.name || r.submitter?.countries?.name || '—'}</td>
              <td>{TYPE_LABELS[r.type] || r.type}</td>
              <td>{formatPeriodLabel(r.period, r.period_start, r.period_end)}</td>
              <td>{when ? when.slice(0, 10) : ''}</td>
              <td><button type="button" className="btn-edit" onClick={() => onReview(r)}>Review</button></td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
